/**
 * @generated SignedSource<<d8bc4ae56f3f56c250f40dc6d80ef7a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePartialItems_item$data = ReadonlyArray<{
  readonly isPartialItem: boolean | null;
  readonly medianL3SoldItemPriceScore: number | null;
  readonly personalizationType: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "usePartialItems_item";
}>;
export type usePartialItems_item$key = ReadonlyArray<{
  readonly " $data"?: usePartialItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePartialItems_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "usePartialItems_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPartialItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "personalizationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medianL3SoldItemPriceScore",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a708cdaea2842dca9fef487cc0d3e3c7";

export default node;
